import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const valuePoints = ['10 e-books prácticos sobre los desafíos más comunes de la crianza', 'Enfoque respetuoso, consciente y sin juicios', 'Herramientas claras para aplicar desde el primer día', 'Respuestas para temas como sueño, pipí en la cama, berrinches, higiene, alimentación y más', 'Acceso inmediato y de por vida', 'Lectura ágil, directa y fácil de comprender'];
export function OfferSection() {
  return <section className="py-24 px-4 bg-[#F5F0E8]" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-146">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-6 leading-tight" data-id="element-147">
            Una biblioteca completa para acompañarte en los momentos más
            importantes de la crianza
          </h2>
          <p className="text-lg text-[#5C4A3A] leading-relaxed" data-id="element-148">
            Este pack reúne 10 e-books prácticos diseñados para ayudarte a
            acompañar a tus hijos con más calma, seguridad y confianza. No son
            teorías ni promesas irreales, sino herramientas claras y respetuosas
            para situaciones reales del día a día familiar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-[#EBE5DB]" data-id="element-149">
          <ul className="space-y-4" data-id="element-150">
            {valuePoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-151">
                <div className="mt-0.5 w-6 h-6 bg-[#5A7D60]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-152">
                  <Check size={14} className="text-[#5A7D60]" data-id="element-153" />
                </div>
                <span className="text-[#5C4A3A] text-lg leading-relaxed" data-id="element-154">
                  {point}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-10 text-[#5C4A3A] italic text-lg" data-id="element-155">
          Adquirir estas guías por separado tendría un coste mucho mayor, pero
          aquí las tienes reunidas en un único pack completo.
        </motion.p>
      </div>
    </section>;
}